/** 'elite' -> 'Elite', 'ifpa' -> 'IFPA' — the tier is the only plan name we have. */
export const formatTierName = (tier) => {
  if (!tier) return '';
  if (tier === 'ifpa') return 'IFPA';
  return tier.charAt(0).toUpperCase() + tier.slice(1);
};
